import containersCache from "_src/engine/packers/containers_cache";
import {arrayDataToNumber, readDDs} from "_src/utils";

export default class Image2D {

  constructor() {

    this.image = new Image();
    this.buffer = null;

    this.width = 0;
    this.height = 0;

  }

  loadSliced(path, id, controller, progressCallback = null, releaseAfterUse = true) {

    return new Promise((resolve, reject) => {

      let imageUrl;

      this.image.onload = () => {
        this.width = this.image.width;
        this.height = this.image.height;
        resolve(this);
        if (releaseAfterUse) URL.revokeObjectURL(imageUrl);
      };

      this.image.onerror = (error) => {
        reject(error);
        URL.revokeObjectURL(imageUrl);
      };

      containersCache.getBuffer(path, id, controller, progressCallback).then((buffer) => {
        if (readDDs(buffer, this)) resolve(this);
        if (this.readRawImage(buffer)) resolve(this);

        const blob = new Blob([buffer]);
        imageUrl = URL.createObjectURL(blob);
        this.image.src = imageUrl;
      }).then(undefined, (error) => reject(error));

    });

  }

  getBuffer() {
    return this.buffer;
  }

  getImage() {
    return this.image;
  }

  readRawImage(buffer) {
    const HEADER_SIZE = 17;
    if (buffer.byteLength < HEADER_SIZE) return false;

    const width = arrayDataToNumber(buffer, 1, 4);
    const height = arrayDataToNumber(buffer, 5, 4);
    const channels = arrayDataToNumber(buffer, 9, 4);

    const valueSize = 4;
    const expectedDataSize = width*height*channels*valueSize;
    const realDataSize = buffer.byteLength - HEADER_SIZE;
    if (expectedDataSize !== realDataSize) return false;

    this.width = width;
    this.height = height;
    this.buffer = new Float32Array(buffer.slice(HEADER_SIZE));

    return true;
  }

}
